'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _Select = require('./Select');

var _Select2 = _interopRequireDefault(_Select);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Filter = require('./Filter');

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FILTER_OPTIONS = [{ label: 'Brands', value: 'brands' }, { label: 'Departments', value: 'departments' }, { label: 'Stores', value: 'stores' }, { label: 'Territories', value: 'regions' }, { label: 'Seasons', value: 'seasons' }, { label: 'Payment Terms', value: 'payment_terms' }, { label: 'Order Status', value: 'order_status' }, { label: 'Market City', value: 'market_city' }, { label: 'Tradeshow', value: 'tradeshow' }];

var Filters = function (_React$Component) {
	_inherits(Filters, _React$Component);

	function Filters() {
		_classCallCheck(this, Filters);

		return _possibleConstructorReturn(this, (Filters.__proto__ || Object.getPrototypeOf(Filters)).apply(this, arguments));
	}

	_createClass(Filters, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    wrapperClass = _props.wrapperClass,
			    label = _props.label,
			    filters = _props.filters;


			var filteredFilterOptions = (0, _underscore.reject)(FILTER_OPTIONS, function (option) {
				for (var i = 0; i < filters.length; i++) {
					if (filters[i].label == option.label) return true;
				}
				return false;
			});

			return _react2.default.createElement(
				'div',
				{ className: "input-wrapper " + wrapperClass },
				label ? _react2.default.createElement(
					'label',
					{ htmlFor: '' },
					label
				) : null,
				this.renderFilters.bind(this, filters)(),
				_react2.default.createElement(_Select2.default, {
					options: filteredFilterOptions,
					clearable: false,
					searchable: false,
					placeholder: '+ Add a filter',
					onChange: this.handleAddFilter.bind(this),
					wrapperClass: 'add-filter'
				})
			);
		}
	}, {
		key: 'renderFilters',
		value: function renderFilters(filters) {
			var _this2 = this;

			if (!filters) return null;
			return filters.map(function (filter, i) {
				return _react2.default.createElement(_Filter2.default, {
					key: i,
					filter: filter,
					label: filter.label,
					onRemove: _this2.handleRemoveFilter.bind(_this2, i),
					onChange: _this2.handleFilterChange.bind(_this2, i),
					value: filter.values,
					multi: true
				});
			});
		}
	}, {
		key: 'handleAddFilter',
		value: function handleAddFilter(filter) {
			var newFilters = this.props.filters.slice();
			newFilters.push({
				label: filter.label,
				type: filter.value,
				values: []
			});
			this.props.onChange(newFilters);
		}
	}, {
		key: 'handleRemoveFilter',
		value: function handleRemoveFilter(index) {
			var newFilters = this.props.filters.slice();
			newFilters.splice(index, 1);
			console.log(index, newFilters);
			this.props.onChange(newFilters);
		}
	}, {
		key: 'handleFilterChange',
		value: function handleFilterChange(i, newValue) {
			var newFilters = this.props.filters.slice();
			newFilters[i].values = newValue.map(function (e) {
				return e.value;
			});
			this.props.onChange(newFilters);
		}
	}]);

	return Filters;
}(_react2.default.Component);

exports.default = Filters;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/form/Filters.js
// module id = 568
// module chunks = 0